import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'phoneformat'
})
export class PhoneformatPipe implements PipeTransform {
    transform(): string {
        return "+1";
    }
}